import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    Select,
    Input,
    Popconfirm,
    message, DatePicker,
} from 'antd';
const { RangePicker } = DatePicker;
const FormItem = Form.Item;
import { actions, asyncGet } from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { formatFormData } from './utils';
moment.locale('zh-cn');
const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {
    constructor(props) {
        super(props);
    }

    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] == -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        values = formatFormData(values);
        this.props.changeSearchValues(values);
        this.props.resetPagination();
        this.props.asyncGet();
    }
    handleReset= () => {
        this.props.form.resetFields();
    }

    // 批量删除调用批量删除接口
    handleDeleteAll = async () => {
        const {transferData} = this.props;
        let {selectedRowKeys} = transferData;
        if (selectedRowKeys.length) {
            selectedRowKeys = JSON.stringify(selectedRowKeys);
            selectedRowKeys = JSON.parse(selectedRowKeys);
            selectedRowKeys = selectedRowKeys.map(item => {
                return {scriptId: item};
            });
            await this.props.delectAll(selectedRowKeys);
            this.props.asyncGet();
        } else {
            message.error('请先选中需要删除的元素');
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>应用管理</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row >
                        <Col span={4}  >
                            <FormItem {...spans} label="时间">
                                {getFieldDecorator('dateTime1')(
                                    <RangePicker
                                        format="YYYY-MM-DD"
                                        placeholder="选择时间"
                                        style={{ width:200 }}
                                    />)}
                            </FormItem>
                        </Col>
                        <Col span={2} style={{ width: 200 }}>
                            <FormItem {...spans} label="ID">
                                {getFieldDecorator('id',{
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入整数',
                                        },
                                    ],
                                })(<Input placeholder="请填写" style={{ width: '50%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem {...spans} label="app名称">
                                {getFieldDecorator('appName')(<Input placeholder="请填写" style={{ width: '60%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem {...spans} label="包名">
                                {getFieldDecorator('packageName')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem {...spans} label="url">
                                {getFieldDecorator('url')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="是否使用" {...spans}>
                                {getFieldDecorator('used')(
                                    <Select allowClear placeholder="ALL" style={{ width: 100 }}>
                                        <Option key='0' value='-1'>
                                            全部
                                        </Option>
                                        <Option key='1' value={0}>
                                            未使用
                                        </Option>
                                        <Option key='2' value={1}>
                                            使用
                                        </Option>
                                    </Select>,
                                )}
                             </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ margin: '0 8px' }} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{ margin: '0 8px' }}>
                                搜索
                            </Button>
                            <Button type="primary" onClick={() => {
                                this.props.editShow();
                            }} style={{ margin: '0 8px' }}>
                                添加
                            </Button>
                            {/*<Popconfirm title="是否删除您选择的所有?" onConfirm={this.handleDeleteAll} >
                                <Button type="primary" style={{ margin: '0 8px' }}>
                                    < a href="#">批量删除</a>
                                </Button>
                            </Popconfirm>*/}
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    transferData: state.appList.transferData,
});

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    resetPagination: () => dispatch(actions.changePagination({ current: 1 })),
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Search));




// WEBPACK FOOTER //
// ./pages/client/AppList/search.js